import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ScreenType,
  NadajPrzesylkeType,
  SposobNadaniaType,
  SposobDoreczeniaType,
} from '../enums/enums';
import {
  changeScreen,
  changeNadajPrzesylkeTyp,
  changeSposobNadaniaStepNumber,
  changeSposobNadaniaTyp,
  changeSposobDoreczeniaTyp,
} from '../store/navigation/navigation.actions';
import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private store = inject(Store);
  private storeService = inject(StoreService);

  changeScreenTo(screen: ScreenType) {
    if (
      screen === ScreenType.OPCJE_NADANIA &&
      this.storeService.isShippingPickupPointPosible() == false
    ) {
      this.changeSposobNadaniaTo(SposobNadaniaType.ZAMOW_KURIERA);
    }
    if (
      screen === ScreenType.OPCJE_DORECZENIA &&
      this.storeService.isShippingPickupPointPosible() == false
    ) {
      this.changeSposobDoreczeniaTo(
        SposobDoreczeniaType.DORECZENIE_PRZEZ_KURIERA
      );
    }
    this.store.dispatch(changeScreen({ screen }));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  changeNadajPrzesylkeTypTo(nadajPrzesylkeTyp: NadajPrzesylkeType) {
    this.store.dispatch(changeNadajPrzesylkeTyp({ nadajPrzesylkeTyp }));
  }

  changeSposobNadaniaStepNumberTo(sposobNadaniaStepNumber: number) {
    this.store.dispatch(
      changeSposobNadaniaStepNumber({ sposobNadaniaStepNumber })
    );
  }

  changeSposobNadaniaTo(sposobNadaniaTyp: SposobNadaniaType) {
    this.store.dispatch(changeSposobNadaniaTyp({ sposobNadaniaTyp }));
  }

  changeSposobDoreczeniaTo(sposobDoreczeniaTyp: SposobDoreczeniaType) {
    this.store.dispatch(changeSposobDoreczeniaTyp({ sposobDoreczeniaTyp }));
  }
}
